import { createFileRoute } from "@tanstack/react-router";
import { UsersListPage } from "../../../components/users/UsersListPage";
import { requireModuleAccess, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/users/")({
  beforeLoad: requireModuleAccess(MODULE_WORKSPACE),
  component: UsersListPage,
});
